import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import LootAnimationModal from "./lootanimation";
import Tslogin from "./Tsconnect";
import { useNavigate } from "react-router-dom";
import { useGetAllReferral } from "./hooks/helper";

const ClaimAvatarPage = forwardRef(({ account, onConnect }: any, ref) => {
  const [isClaimed, setIsClaimed] = useState(false);
  const [showLootAnimation, setShowLootAnimation] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRewardModal, setShowRewardModal] = useState(false);
  const [hasNoTraits, setHasNoTraits] = useState(false);
  const [pendingClaim, setPendingClaim] = useState(false);

  const navigate = useNavigate();
  const { data, refetch } = useGetAllReferral();
  const userdetails = data?.user ?? null;

  const runClaimFlow = async () => {
    await refetch();
  
    let traits = userdetails?.traits;
    console.log("traits raw:", traits);
    if (typeof traits === "string") {
      try {
        traits = JSON.parse(traits);
      } catch (e) {
        traits = [];
      }
    }
  
    console.log("Parsed traits:", traits);
    console.log("Traits length:", traits?.length);
  
    const noTraits = !traits || traits.length < 3;
    const shouldRunAnimation = noTraits || hasNoTraits;
  
    console.log("noTraits:", noTraits, "shouldRunAnimation:", shouldRunAnimation);
  
    if (noTraits) {
      setHasNoTraits(true);  
    }
  
    setIsClaimed(true);
  
    if (shouldRunAnimation) {
      setShowLootAnimation(true);
      setTimeout(() => {
        setShowLootAnimation(false);
        navigate("/avatar");
      }, 4000);
    } else {
      navigate("/avatar");
    }
  };
  

  const handleClaimClick = () => {
    if (!account?.isConnected) {
      setShowLoginModal(true);
      setHasNoTraits(true); // Assume missing traits until proven otherwise
      setPendingClaim(true);
      onConnect?.();
      return;
    }
    runClaimFlow();
  };

  // ✅ Wait for both `userdetails` and wallet connection before running claim flow
  useEffect(() => {
    if (account?.isConnected && pendingClaim && userdetails) {
      setShowLoginModal(false);
      setPendingClaim(false);
      runClaimFlow();
    }
  }, [account?.isConnected, pendingClaim, userdetails]);

  const handleCloseModal = () => {
    setShowLootAnimation(false);
  };

  useImperativeHandle(ref, () => ({
    triggerClaim: handleClaimClick,
  }));

  return (
    <>
      {showLootAnimation && (
        <LootAnimationModal onClose={handleCloseModal} />
      )}
      {showLoginModal && (
        <Tslogin onCancelProcess={() => setShowLoginModal(false)} />
      )}
      {/* {showRewardModal && <WonRewardModal onClose={handleCloseModal} />} */}
    </>
  );
});

export default ClaimAvatarPage;
